module.exports = __webpack_public_path__ + "img/tiexue.6bd72d8f.svg";